import { Box, useSlotRecipe } from '@chakra-ui/react';

export const STRIPE_PATTERN =
  'repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,0.4) 2px, rgba(255,255,255,0.4) 4px)';

export interface BarSegmentItem {
  key: string;
  value: number;
  color: string;
  pattern?: boolean;
}

interface BarSegmentProps {
  items: BarSegmentItem[];
  size?: 'sm' | 'md';
}

export const BarSegment: React.FC<BarSegmentProps> = ({ items, size = 'md' }) => {
  const recipe = useSlotRecipe({ key: 'barSegment' });
  const styles = recipe({ size });

  const hasData = items.some((item) => item.value > 0);
  const total = items.reduce((sum, item) => sum + item.value, 0);

  return (
    <Box css={styles.root}>
      {items.map((item) => {
        const percent = hasData ? (item.value / total) * 100 : 100 / items.length;
        return (
          <Box
            key={item.key}
            flex={`${Math.max(percent, 1)}`}
            bg={item.color}
            css={styles.segment}
            opacity={item.value === 0 && hasData ? 0.4 : 1}
            backgroundImage={item.pattern ? STRIPE_PATTERN : undefined}
          />
        );
      })}
    </Box>
  );
};
